/* La banniere des feuilles personnalisees, sur l'accueil.
 *
 * Le titre qui s'ecrit tout seul n'est pas une imitation : c'est le MEME
 * moteur que l'apercu de la fiche produit (`apercu-titre.js`), donc les memes
 * lettres, la meme recherche de taille, la meme bascule a deux lignes. Ce que
 * la visiteuse voit sur l'accueil est exactement ce qui sortira de
 * l'imprimante. Une police web approchante aurait promis autre chose.
 *
 * Rien ne se charge tant que la banniere n'est pas a l'ecran : la planche de
 * lettres et les feuilles vierges pesent quelques centaines de kilo-octets, et
 * la banniere vit sous le premier ecran.
 */
(function () {
  "use strict";

  var REPOS = window.matchMedia
    && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Les rythmes de la frappe, en millisecondes. */
  var LETTRE = 105;   // une lettre de plus
  var PAUSE = 3600;   // le titre fini reste lisible
  var EFFACE = 40;    // une lettre de moins
  var REPRISE = 700;  // avant de recommencer

  function image(url) {
    return new Promise(function (ok, ko) {
      var im = new Image();
      im.onload = function () { ok(im); };
      im.onerror = ko;
      im.src = url;
    });
  }

  /* La feuille vierge du modele demande. Liquid l'a normalement deja posee
   * dans l'attribut ; la liste de secours ne sert que si le metachamp de la
   * boutique etait vide au moment du rendu. */
  function apercu(toile, racine) {
    if (toile.dataset.apercu) return Promise.resolve(toile.dataset.apercu);
    return fetch(racine.dataset.modeles)
      .then(function (r) { return r.json(); })
      .then(function (index) {
        var m = (index.modeles || []).filter(function (x) {
          return x.sku === toile.dataset.sku;
        })[0];
        if (!m) throw new Error("modele inconnu : " + toile.dataset.sku);
        return m.apercu;
      });
  }

  function preparer(atelier, toile, racine) {
    var ctx = toile.getContext("2d");
    var moteur = atelier.moteur(ctx);
    var K = toile.width / atelier.C.toile[0];
    toile.height = Math.round(atelier.C.toile[1] * K);

    return apercu(toile, racine).then(image).then(function (fond) {
      function rendre(texte) {
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, toile.width, toile.height);
        ctx.drawImage(fond, 0, 0, toile.width, toile.height);
        /* `true` : on garde l'espace en cours de frappe, sinon le nettoyage
           avalerait celui qu'on vient de taper et les mots se colleraient. */
        var titre = moteur.normaliser(texte, true);
        if (titre) {
          ctx.setTransform(K, 0, 0, K, 0, 0);
          moteur.dessiner(titre);
          ctx.setTransform(1, 0, 0, 1, 0, 0);
        }
      }
      return rendre;
    });
  }

  /* La frappe. Un seul minuteur a la fois, remis a zero des que la banniere
   * quitte l'ecran : rien ne tourne dans un onglet qu'on ne regarde pas. */
  function animer(rendre, titre) {
    var minuteur = null;
    var n = 0;
    var sens = 1;

    function pas() {
      rendre(titre.slice(0, n));
      var delai;
      if (sens > 0) {
        if (n >= titre.length) { sens = -1; delai = PAUSE; }
        else { n += 1; delai = LETTRE; }
      } else if (n <= 0) {
        sens = 1;
        delai = REPRISE;
      } else {
        n -= 1;
        delai = EFFACE;
      }
      minuteur = setTimeout(pas, delai);
    }

    return {
      partir: function () { if (!minuteur) pas(); },
      arreter: function () { clearTimeout(minuteur); minuteur = null; }
    };
  }

  function demarrer(racine) {
    var toiles = Array.prototype.slice.call(racine.querySelectorAll("[data-toile]"));
    if (!toiles.length) return;

    ApercuTitre.charger({
      constantes: racine.dataset.constantes,
      glyphes: racine.dataset.glyphes,
      planche: racine.dataset.planche
    }).then(function (atelier) {
      return Promise.all(toiles.map(function (toile) {
        return preparer(atelier, toile, racine).then(function (rendre) {
          var titre = toile.dataset.titre || "";
          if (REPOS || toile.dataset.anime !== "true") {
            rendre(titre);
            return null;
          }
          rendre("");
          return animer(rendre, titre);
        });
      }));
    }).then(function (frappes) {
      racine.classList.add("pc-banniere--prete");
      var vivantes = frappes.filter(Boolean);
      if (!vivantes.length || !window.IntersectionObserver) {
        vivantes.forEach(function (f) { f.partir(); });
        return;
      }
      new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          vivantes.forEach(function (f) {
            if (e.isIntersecting) { f.partir(); } else { f.arreter(); }
          });
        });
      }, { threshold: 0.15 }).observe(racine);
    }).catch(function (e) {
      /* Si le dessin ne charge pas, la banniere garde son texte et son bouton :
         c'est le lien vers la fiche qui compte, pas la demonstration. */
      racine.classList.add("pc-banniere--sans-dessin");
      if (window.console) console.error("banniere-perso :", e);
    });
  }

  function init() {
    var bannieres = Array.prototype.slice.call(
      document.querySelectorAll("[data-banniere-perso]")
    );
    if (!bannieres.length) return;

    if (!window.IntersectionObserver) {
      bannieres.forEach(demarrer);
      return;
    }
    /* On ne descend les fichiers du moteur qu'a l'approche de la banniere. */
    var guetteur = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        guetteur.unobserve(e.target);
        demarrer(e.target);
      });
    }, { rootMargin: "400px" });
    bannieres.forEach(function (b) { guetteur.observe(b); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
